import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import StrikethroughSIcon from '@mui/icons-material/StrikethroughS';
import { CompositeDecorator, Editor, EditorState, RichUtils } from 'draft-js';
import 'draft-js/dist/Draft.css';
import React, { useEffect, useState } from 'react';
import { Buttons, InsertText, Main } from './TextEditor.Styles';

const LinkDecorator = (props) => {
  const { url } = props.contentState.getEntity(props.entityKey).getData();
  return (
    <a
      href={url}
      style={{ color: '#1a0dab', textDecoration: 'underline' }}
      target="_blank"
      rel="noopener noreferrer"
    >
      {props.children}
    </a>
  );
};

const linkStrategy = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === 'LINK'
    );
  }, callback);
};

const decorator = new CompositeDecorator([
  {
    strategy: linkStrategy,
    component: LinkDecorator,
  },
]);

const addLink = (editorState, url) => {
  const contentState = editorState.getCurrentContent();
  const contentWithEntity = contentState.createEntity('LINK', 'MUTABLE', {
    url,
  });
  const entityKey = contentWithEntity.getLastCreatedEntityKey();
  const newEditorState = EditorState.push(
    editorState,
    contentWithEntity,
    'apply-entity'
  );
  return RichUtils.toggleLink(
    newEditorState,
    newEditorState.getSelection(),
    entityKey
  );
};

const TextEditor = ({ value, onChange, className }) => {
  const [editorState, setEditorState] = useState(() =>
    typeof value === 'object' && value.getCurrentContent
      ? EditorState.set(value, { decorator })
      : EditorState.createEmpty(decorator)
  );

  useEffect(() => {
    if (
      typeof value === 'object' &&
      value.getCurrentContent &&
      value !== editorState
    ) {
      setEditorState(EditorState.set(value, { decorator }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleEditorChange = (newState) => {
    setEditorState(newState);
    onChange(newState);
  };

  const toggleInlineStyle = (style) => {
    const newState = RichUtils.toggleInlineStyle(editorState, style);
    setEditorState(newState);
    onChange(newState);
  };

  const handleLink = () => {
    const url = prompt('Digite a URL do link:');
    if (url) {
      const newState = addLink(editorState, url);
      setEditorState(newState);
      onChange(newState);
    }
  };

  return (
    <Main className={className}>
      <Buttons>
        <button type="button" onClick={() => toggleInlineStyle('BOLD')}>
          <FormatBoldIcon htmlColor="rgb(102, 102, 102)" fontSize="small" />
        </button>
        <button type="button" onClick={() => toggleInlineStyle('ITALIC')}>
          <FormatItalicIcon htmlColor="rgb(102, 102, 102)" fontSize="small" />
        </button>
        <button type="button" onClick={() => toggleInlineStyle('UNDERLINE')}>
          <FormatUnderlinedIcon
            htmlColor="rgb(102, 102, 102)"
            fontSize="small"
          />
        </button>
        <button
          type="button"
          onClick={() => toggleInlineStyle('STRIKETHROUGH')}
        >
          <StrikethroughSIcon htmlColor="rgb(102, 102, 102)" fontSize="small" />
        </button>
        <button type="button" onClick={handleLink}>
          <InsertLinkIcon htmlColor="rgb(102, 102, 102)" fontSize="small" />
        </button>
      </Buttons>
      <InsertText>
        <Editor editorState={editorState} onChange={handleEditorChange} />
      </InsertText>
    </Main>
  );
};

export default TextEditor;
